<template>
  <div class="flex bg-tabs-bg rounded-[12px] h-[44px] tabs" style="--columns: 2;">
    <slot></slot>
  </div>
</template>

<script lang="ts" setup>

</script>